// MEWSPACE: sticky Add to cart bar for the product page.
if (!customElements.get('mew-sticky-atc')) {
  customElements.define(
    'mew-sticky-atc',
    class MewStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.priceEl = this.querySelector('[data-mew-sticky-price]');
        this.buttonEl = this.querySelector('[data-mew-sticky-button]');
        this.buttonEl.addEventListener('click', () => this.mainButton()?.click());
        this.hidden = false;

        // Re-bind after Dawn swaps the product info on variant change.
        this.observe();
        this.unsubscribe = window.subscribe?.(window.PUB_SUB_EVENTS?.variantChange, () =>
          requestAnimationFrame(() => {
            this.observe();
            this.sync();
          })
        );
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
      }

      mainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      observe() {
        const target = this.mainButton();
        this.observer?.disconnect();
        if (!target) return;
        this.observer = new IntersectionObserver(([entry]) => {
          // Show only once the main button has scrolled above the viewport.
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', show);
          this.setAttribute('aria-hidden', String(!show));
          this.buttonEl.tabIndex = show ? 0 : -1;
          if (show) this.sync();
        });
        this.observer.observe(target);
      }

      sync() {
        const wrapper = document.querySelector(`#price-${this.sectionId} .price`);
        const price = wrapper?.classList.contains('price--on-sale')
          ? wrapper.querySelector('.price-item--sale')
          : wrapper?.querySelector('.price__regular .price-item--regular');
        if (price && this.priceEl) this.priceEl.textContent = price.textContent.trim();

        const main = this.mainButton();
        if (main) {
          this.buttonEl.disabled = main.disabled;
          this.buttonEl.textContent = main.querySelector('span')?.textContent.trim() || this.buttonEl.textContent;
        }
      }
    }
  );
}
